import { render } from "./LoginSkeleton.vue?vue&type=template&id=5691a8d0"
import script from "./LoginSkeleton.vue?vue&type=script&lang=js"
export * from "./LoginSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__